module["exports"] = [
  "9##-###-###",
  "9##.###.###",
  "9## ### ###",
  "9########"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/phone_number/formats.js
// module id = 2246
// module chunks = 2